import { ProductBatchItemModel } from "./ProductBatchItemModel";
import { ProductBatchItemLogModel } from "./ProductBatchItemLogModel";
import { ProductBatchTypeEnum } from "@c2b/muven-commons";

export class ProductBatchItemWithLogsModel {
	logs: ProductBatchItemLogModel[];
	items: ProductBatchItemModel[];
	batchType: ProductBatchTypeEnum;

	constructor(pw: Partial<ProductBatchItemWithLogsModel>, batchType: ProductBatchTypeEnum) {
		Object.assign(this, pw)
		this.batchType = batchType;

		this._parseLogs()
		this._parseItems()
	}

	private _parseLogs():void {
		this.logs = (this.logs || []).map((log) => new ProductBatchItemLogModel(log))
	}

	private _parseItems():void {
		this.items = (this.items || []).map((item) => new ProductBatchItemModel(item, this.batchType))
	}
}
